import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment";
import { Modal, ModalHeader, ModalBody, ModalFooter, Collapse } from "reactstrap";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import feederListActions from "../../_actions/feederListActions";
import CustomDatePickerInput from "../_common/CustomDatePickerInput";
import ProjSelector from "../_common/ProjSelector";
import { actionScripts } from "../../_helpers/actionScripts";
import projActions from "../../_actions/projActions";
import { modalTabIds } from "../../_constants/modalTabIds";

class AdrSearchModal extends Component {
  // Note: state's non-UI properties will become search query param object.
  state = {
    advSearchCollapsed: true,
    projectId: null,
    dateSearchType: "allDates",
    singleDate: new Date(),
    dateFrom: new Date(),
    dateTo: new Date(),
    reportNos: [], // [*int]
    selectedReportNos: [],
    reportNoBaseList: [], // [*int]
    userId: 0,
    selectedUser: [],
    commentKeywordIds: [], // [*int]
    selectedCommentKeywords: [],
    locationIds: [], // [*int]
    selectedLocations: [],
    itemIds: [], // [*int]
    selectedItems: [],
    ccoIds: [], // [*int]
    selectedCcos: [],
    contractorIds: [], // [*int]
    selectedContractors: [],
    laborIds: [], // [*int]
    selectedLabors: [],
    equipmentIds: [], // [*int]
    selectedEquipment: [],
    generalcomments: "", // [*string]
    workperformed: "", // [*string]
    isControllingOperation: false,
    isDisputed: false,
  };

  // Multi-select filters: [idsField, selectedField, listsProp, valueKey, labelKey].
  // Used to rebuild selected options from ids when modifying a previous search.
  multiSelectFilters = [
    ["commentKeywordIds", "selectedCommentKeywords", "projKeywordLists", "keywordId", "keywordTag"],
    ["locationIds", "selectedLocations", "projLocationLists", "locationId", "name"],
    ["itemIds", "selectedItems", "projItemLists", "bidItemId", "itemListCaption"],
    ["ccoIds", "selectedCcos", "projCcoLists", "ccoId", "ccoListCaption"],
    ["contractorIds", "selectedContractors", "projContractorLists", "contractorId", "name"],
    ["laborIds", "selectedLabors", "projLaborLists", "laborId", "fullName"],
    ["equipmentIds", "selectedEquipment", "projEquipLists", "equipmentId", "numberDesc"],
  ];

  componentDidUpdate() {
    this.syncSelectedOptions();
  }

  /**
   * Restores the form from the search that produced this results tab (Modify Search).
   * Ids are restored immediately; dropdown labels are filled in by syncSelectedOptions
   * once the project's feeder lists have loaded.
   */
  restorePrevSearchParams = (prev) => {
    const ids = (arr) => (arr || []).slice();
    const restored = {
      dateSearchType: prev.dateQueryType || "allDates",
      singleDate: prev.singleDate ? new Date(prev.singleDate) : new Date(),
      dateFrom: prev.dateFrom ? new Date(prev.dateFrom) : new Date(),
      dateTo: prev.dateTo ? new Date(prev.dateTo) : new Date(),
      reportNos: ids(prev.reportNos),
      selectedReportNos: (prev.reportNos || []).map((rn) => ({ value: rn, label: rn })),
      userId: prev.userId || 0,
      generalcomments: prev.generalcomments || "",
      workperformed: prev.workperformed || "",
      isControllingOperation: !!prev.isControllingOperation,
      isDisputed: !!prev.isDisputed,
    };
    this.multiSelectFilters.forEach(([idsField, selectedField]) => {
      restored[idsField] = ids(prev[idsField]);
      restored[selectedField] = [];
    });
    const hasAdvancedFilters =
      this.multiSelectFilters.some(([idsField]) => restored[idsField].length > 0) ||
      restored.generalcomments !== "" ||
      restored.workperformed !== "" ||
      restored.isControllingOperation ||
      restored.isDisputed;
    restored.advSearchCollapsed = !hasAdvancedFilters;
    return restored;
  };

  syncSelectedOptions = () => {
    const { projStaffLists } = this.props;
    const { projectId, userId, selectedUser } = this.state;
    if (!projectId) return;

    const updates = {};
    this.multiSelectFilters.forEach(([idsField, selectedField, listsProp, valueKey, labelKey]) => {
      const idList = this.state[idsField];
      const selected = this.state[selectedField];
      const list = this.props[listsProp] && this.props[listsProp][projectId];
      if (!list || idList.length === 0 || (selected && selected.length > 0)) return;
      const options = list
        .filter((o) => idList.includes(o[valueKey]))
        .map((o) => ({ value: o[valueKey], label: o[labelKey] }));
      // Drop ids that no longer exist in the project so no hidden filter is applied.
      updates[idsField] = options.map((o) => o.value);
      updates[selectedField] = options;
    });

    const staff = projStaffLists && projStaffLists[projectId];
    if (userId && staff && !(selectedUser && selectedUser.value)) {
      const u = staff.find((s) => s.userId === userId);
      updates.userId = u ? userId : 0;
      updates.selectedUser = u ? { value: u.userId, label: u.fullName } : null;
    }

    if (Object.keys(updates).length > 0) this.setState(updates);
  };

  componentDidMount() {
    let reportNoBaseList = [];
    const { dispatch, initProjectId, prevSearchParams } = this.props;

    // Fetch feederLists if projectId is specified
    dispatch(feederListActions.getAllStatic());
    if (initProjectId) {
      dispatch(feederListActions.getAll(initProjectId));
      dispatch(feederListActions.getAllStatic());
      dispatch(projActions.fetchAllStaff(initProjectId));
      this.setState({ projectId: initProjectId });
    }

    // Populate report number dropdown
    for (let i = 0; i < 1001; i++) {
      reportNoBaseList.push(i);
    }

    this.setState({
      reportNoBaseList,
      ...(prevSearchParams && this.restorePrevSearchParams(prevSearchParams)),
    });
  }

  toggleAdvSearchCollapse = () =>
    this.setState({ advSearchCollapsed: !this.state.advSearchCollapsed });

  onProjectSelect = (projectId) => {
    const { dispatch } = this.props;
    if (projectId) {
      dispatch(feederListActions.getAll(projectId));
      dispatch(feederListActions.getAllStatic());
      dispatch(projActions.fetchAllStaff(projectId));
      this.setState({ projectId });
    } else this.setState({ projectId: 0 });
  };

  handleChange_singleDate = (value) => this.setState({ singleDate: value });

  handleChange_dateFrom = (value) => this.setState({ dateFrom: value });

  handleChange_dateTo = (value) => this.setState({ dateTo: value });

  handleChange_reportNos = (selectedReportNos) =>
    this.setState({
      reportNos: selectedReportNos ? selectedReportNos.map((r) => r.value) : [],
      selectedReportNos,
    });

  handleChange_user = (selectedUser) =>
    this.setState({ userId: selectedUser.value, selectedUser });

  handleChange_selectSingle = (fieldName, optionFieldName) => (selectedOption) => {
    this.setState({
      [fieldName]: selectedOption.value,
      [optionFieldName]: selectedOption,
    });
  };

  handleChange_selectMulti = (fieldName, optionFieldName) => (selectedOptions) => {
    this.setState({
      [fieldName]: selectedOptions ? selectedOptions.map((o) => o.value) : [],
      [optionFieldName]: selectedOptions,
    });
  };

  handleChange_checkbox = (fieldName) => (e) =>
    this.setState({ [fieldName]: e.target.checked });

  handleSubmit = async (e) => {
    e.preventDefault();
    const {
      projectId,
      dateSearchType,
      singleDate,
      dateFrom,
      dateTo,
      reportNos,
      userId,
      commentKeywordIds,
      locationIds,
      itemIds,
      ccoIds,
      contractorIds,
      laborIds,
      equipmentIds,
      generalcomments,
      workperformed,
      isControllingOperation,
      isDisputed,
    } = this.state;
    const { tabId } = this.props;

    // All searchParam Id's are strings. Convert them to numbers,
    // and build the searchParams query object.
    const searchParams = {
      projectId, // projectId is always required. Cannot be null
      dateQueryType: dateSearchType,
      singleDate: moment(singleDate).format(),
      dateFrom: moment(dateFrom).format(),
      dateTo: moment(dateTo).format(),
      reportNos: reportNos ? reportNos.map((rNo) => parseInt(rNo, 10)) : [],
      userId: userId ? parseInt(this.state.userId, 10) : 0,
      commentKeywordIds: commentKeywordIds
        ? commentKeywordIds.map((ck) => parseInt(ck, 10))
        : [],
      locationIds: locationIds ? locationIds.map((l) => parseInt(l, 10)) : [],
      itemIds: itemIds ? itemIds.map((i) => parseInt(i, 10)) : [],
      ccoIds: ccoIds ? ccoIds.map((c) => parseInt(c, 10)) : [],
      contractorIds: contractorIds ? contractorIds.map((c) => parseInt(c, 10)) : [],
      laborIds: laborIds ? laborIds.map((l) => parseInt(l, 10)) : [],
      equipmentIds: equipmentIds ? equipmentIds.map((e) => parseInt(e, 10)) : [],
      generalcomments: generalcomments || "",
      workperformed: workperformed || "",
      isControllingOperation: isControllingOperation || false,
      isDisputed: isDisputed || false,
    };

    // console.log("Current searchParams: ", searchParams);

    // If tabId === modalTabIds.ADR_SEARCH, the current adrSearchModal instance
    // is for a NEW search.
    await actionScripts.SEARCH_ADR.run(
      searchParams,
      tabId === modalTabIds.ADR_SEARCH ? null : tabId
    );


    this.resetStateAndClose();
  };

  handleClose = (e) => {
    e.preventDefault();
    this.resetStateAndClose();
  };

  resetStateAndClose = () => {
    this.setState(
      {
        projectId: 0,
        advSearchCollapsed: true,
        selectedDateSearchType: "singleDate",
        singleDate: new Date(),
        dateFrom: new Date(),
        dateTo: new Date(),
        reportNos: [],
        selectedReportNos: [],
        userId: 0,
        selectedUser: null,
        commentKeywordIds: [],
        locationIds: [],
        selectedLocations: [],
        itemIds: [],
        selectedItems: [],
        ccoIds: [],
        selectedCcos: [],
        contractorIds: [],
        selectedContractors: [],
        laborIds: [],
        selectedLabors: [],
        equipmentIds: [],
        selectedEquipment: [],
        generalcomments: "", // <-- reset generalcomments
        workperformed: "", // <-- reset workperformed
        isControllingOperation: false,
        isDisputed: false,
      },
      this.props.toggleAdrSearchModal()
    );
  };

  resetProjectId = () => this.setState({ projectId: 0 });

  handleChange_dateSearchType = (e) => {
    this.setState({ dateSearchType: e.target.name });
  };

  handleDateChangeRaw = (e) => {
    e.preventDefault();
  };

  renderDateSelectors = () => {
    const { searching } = this.props;
    const {
      dateSearchType,
      projectId,
      dateFrom,
      dateTo,
      singleDate,
      selectedReportNos,
      reportNoBaseList,
    } = this.state;
    return (
      <div className="card mx-2 mt-2">
        <div className="card-body pb-0">
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <div className="custom-control custom-radio date-toggle">
                <input
                  type="radio"
                  name="allDates"
                  id="allDates"
                  checked={dateSearchType === "allDates"}
                  onChange={this.handleChange_dateSearchType}
                  className="custom-control-input"
                  disabled={!projectId || searching}
                />
                <label htmlFor="allDates" className="custom-control-label">
                  All dates
                </label>
              </div>
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <div className="custom-control custom-radio date-toggle">
                <input
                  type="radio"
                  name="singleDate"
                  id="singleDate"
                  checked={dateSearchType === "singleDate"}
                  onChange={this.handleChange_dateSearchType}
                  className="custom-control-input"
                  disabled={!projectId || searching}
                />
                <label htmlFor="singleDate" className="custom-control-label">
                  Single Date:
                </label>
              </div>
            </div>
            <div className="col-sm-4">
              <DatePicker
                customInput={<CustomDatePickerInput />}
                name="singleDate"
                id="singleDate"
                selected={singleDate}
                onChange={this.handleChange_singleDate}
                className="form-control"
                disabled={dateSearchType !== "singleDate" || !projectId || searching}
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <div className="custom-control custom-radio date-toggle">
                <input
                  type="radio"
                  name="dateRange"
                  id="dateRange"
                  checked={dateSearchType === "dateRange"}
                  onChange={this.handleChange_dateSearchType}
                  className="custom-control-input"
                  disabled={!projectId || searching}
                />
                <label htmlFor="dateRange" className="custom-control-label">
                  Date Range:
                </label>
              </div>
            </div>
            <div className="col-sm-9">
              <div className="row mb-0 ml-0">
                <label htmlFor="dateFrom" className="form-label mx-2 my-auto">
                  From:
                </label>
                <div className="col-4">
                  <DatePicker
                    customInput={
                      <CustomDatePickerInput
                        disabled={dateSearchType !== "dateRange" || !projectId}
                      />
                    }
                    name="dateFrom"
                    id="dateFrom"
                    selected={dateFrom}
                    onChange={this.handleChange_dateFrom}
                    className="form-control"
                    disabled={dateSearchType !== "dateRange" || !projectId || searching}
                  />
                </div>
                <label htmlFor="dateTo" className="form-label mx-2 my-auto">
                  To:
                </label>
                <div className="col-4">
                  <DatePicker
                    customInput={
                      <CustomDatePickerInput
                        disabled={dateSearchType !== "dateRange" || !projectId}
                      />
                    }
                    name="dateTo"
                    id="dateTo"
                    selected={dateTo}
                    onChange={this.handleChange_dateTo}
                    className="form-control"
                    disabled={dateSearchType !== "dateRange" || !projectId || searching}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <div className="custom-control custom-radio date-toggle">
                <input
                  type="radio"
                  name="reportNos"
                  id="reportNos"
                  checked={dateSearchType === "reportNos"}
                  onChange={this.handleChange_dateSearchType}
                  className="custom-control-input"
                  disabled={!projectId || searching}
                />
                <label htmlFor="reportNos" className="custom-control-label">
                  Report Numbers:
                </label>
              </div>
            </div>
            <div className="col-sm-9">
              <Select
                name="reportNos"
                id="reportNos"
                value={selectedReportNos}
                options={reportNoBaseList.map((rn) => ({
                  value: rn,
                  label: rn,
                }))}
                onChange={this.handleChange_selectMulti("reportNos", "selectedReportNos")}
                isDisabled={dateSearchType !== "reportNos" || !projectId || searching}
                placeholder="(Select or Key-in Report No.)"
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderAuthorSelector = () => {
    const { projectId, selectedUser } = this.state;
    const { projStaffLists, searching } = this.props;

    return (
      <div className="card mx-2 mt-2">
        <div className="card-body pb-0">
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="author" className="col-form-label">
                Author:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <Select
                name="userId"
                id="userId"
                value={selectedUser}
                options={
                  projStaffLists &&
                  projStaffLists[projectId] &&
                  projStaffLists[projectId].map((user) => ({
                    value: user.userId,
                    label: user.fullName,
                  }))
                }
                onChange={this.handleChange_selectSingle("userId", "selectedUser")}
                isDisabled={!projectId || searching}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderAdvancedFilters = () => {
    const {
      projItemLists,
      projLocationLists,
      projCcoLists,
      projContractorLists,
      projLaborLists,
      projEquipLists,
      projKeywordLists,
      searching,
    } = this.props;
    const {
      projectId,
      selectedCommentKeywords,
      selectedLocations,
      selectedItems,
      selectedCcos,
      selectedContractors,
      selectedEquipment,
      selectedLabors,
      isControllingOperation,
      isDisputed,
    } = this.state;

    return (
      <div className="card mx-2">
        <div className="card-body pb-0">
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="commentKeywordIds" className="col-form-label">
                Comment Keywords:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <Select
                name="commentKeywordIds"
                id="commentKeywordIds"
                value={selectedCommentKeywords}
                options={((projectId && projKeywordLists[projectId]) || []).map((k) => ({
                  value: k.keywordId,
                  label: k.keywordTag,
                }))}
                onChange={this.handleChange_selectMulti(
                  "commentKeywordIds",
                  "selectedCommentKeywords"
                )}
                isDisabled={!projectId || !projKeywordLists[projectId] || searching}
                placeholder="(Select or Key-in Keywords)"
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="locationIds" className="col-form-label">
                Locations:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <Select
                name="locationIds"
                id="locationIds"
                value={selectedLocations}
                options={((projectId && projLocationLists[projectId]) || []).map((l) => ({
                  value: l.locationId,
                  label: l.name,
                }))}
                onChange={this.handleChange_selectMulti(
                  "locationIds",
                  "selectedLocations"
                )}
                placeholder="(Select or Key-in Locations)"
                isDisabled={!projectId || !projLocationLists[projectId] || searching}
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="items" className="col-form-label">
                Items:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <Select
                name="itemIds"
                id="itemIds"
                value={selectedItems}
                options={((projectId && projItemLists[projectId]) || []).map((i) => ({
                  value: i.bidItemId,
                  label: i.itemListCaption,
                }))}
                onChange={this.handleChange_selectMulti("itemIds", "selectedItems")}
                placeholder="(Select or Key-in Items)"
                isDisabled={!projectId || !projItemLists[projectId] || searching}
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="ccos" className="col-form-label">
                CCOs:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <Select
                name="ccoIds"
                id="ccoIds"
                value={selectedCcos}
                options={((projectId && projCcoLists[projectId]) || []).map((c) => ({
                  value: c.ccoId,
                  label: c.ccoListCaption,
                }))}
                onChange={this.handleChange_selectMulti("ccoIds", "selectedCcos")}
                placeholder="(Select or Key-in CCO's)"
                isDisabled={!projectId || !projCcoLists[projectId] || searching}
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="contractors" className="col-form-label">
                Contractors:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <Select
                name="contractorIds"
                id="contractorIds"
                value={selectedContractors}
                options={((projectId && projContractorLists[projectId]) || []).map(
                  (c) => ({
                    value: c.contractorId,
                    label: c.name,
                  })
                )}
                onChange={this.handleChange_selectMulti(
                  "contractorIds",
                  "selectedContractors"
                )}
                placeholder="(Select or Key-in Contractors)"
                isDisabled={!projectId || !projContractorLists[projectId] || searching}
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="labors" className="col-form-label">
                Labors:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <Select
                name="laborIds"
                id="laborIds"
                value={selectedLabors}
                options={((projectId && projLaborLists[projectId]) || []).map((l) => ({
                  value: l.laborId,
                  label: l.fullName,
                }))}
                onChange={this.handleChange_selectMulti("laborIds", "selectedLabors")}
                placeholder="(Select or Key-in Labors)"
                isDisabled={!projectId || !projLaborLists[projectId] || searching}
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="equipment" className="col-form-label">
                Equipment:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <Select
                name="equipmentIds"
                id="equipmentIds"
                value={selectedEquipment}
                options={((projectId && projEquipLists[projectId]) || []).map((e) => ({
                  value: e.equipmentId,
                  label: e.numberDesc,
                }))}
                onChange={this.handleChange_selectMulti(
                  "equipmentIds",
                  "selectedEquipment"
                )}
                placeholder="(Select or Key-in Equipment)"
                isDisabled={!projectId || !projEquipLists[projectId] || searching}
                isMulti
                isClearable
                isSearchable
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="workperformed" className="col-form-label">
                Work Description:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <textarea
                name="workperformed"
                id="workperformed"
                value={this.state.workperformed}
                onChange={e => this.setState({ workperformed: e.target.value })}
                placeholder="Type to search..."
                disabled={!projectId || !projEquipLists[projectId] || searching}
                className="form-control"
                rows={3}
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto" />
            <div className="col-sm-9 my-auto">
              <div className="custom-control custom-checkbox custom-control-inline">
                <input
                  type="checkbox"
                  name="isControllingOperation"
                  id="isControllingOperation"
                  checked={isControllingOperation}
                  onChange={this.handleChange_checkbox("isControllingOperation")}
                  className="custom-control-input"
                  disabled={!projectId || searching}
                />
                <label
                  htmlFor="isControllingOperation"
                  className="custom-control-label"
                >
                  Controlling Operation
                </label>
              </div>
              <div className="custom-control custom-checkbox custom-control-inline">
                <input
                  type="checkbox"
                  name="isDisputed"
                  id="isDisputed"
                  checked={isDisputed}
                  onChange={this.handleChange_checkbox("isDisputed")}
                  className="custom-control-input"
                  disabled={!projectId || searching}
                />
                <label htmlFor="isDisputed" className="custom-control-label">
                  Disputed Work
                </label>
              </div>
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-sm-3 my-auto">
              <label htmlFor="generalcomments" className="col-form-label">
                General Comments:
              </label>
            </div>
            <div className="col-sm-9 my-auto">
              <textarea
                name="generalcomments"
                id="generalcomments"
                value={this.state.generalcomments}
                onChange={e => this.setState({ generalcomments: e.target.value })}
                placeholder="Type to search..."
                disabled={!projectId || !projEquipLists[projectId] || searching}
                className="form-control"
                rows={3}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      tabId,
      initProjectId,
      showProjectsFor,
      showAdrSearchModal,
      className,
      onSubmit,
      searching,
    } = this.props;
    const { projectId, advSearchCollapsed } = this.state;

    return (
      <Modal
        isOpen={showAdrSearchModal}
        toggle={this.handleClose}
        className={className}
        fade={false}
        size="lg"
      >
        <ModalHeader toggle={this.handleClose} className="bg-lightgray">
          Search daily report
        </ModalHeader>
        <ModalBody>
          <form id="adrSearchModalForm" onSubmit={onSubmit}>
            <ProjSelector
              tabId={tabId}
              initProjectId={initProjectId || undefined}
              showProjectsFor={showProjectsFor}
              onProjectSelect={this.onProjectSelect}
              resetProjectId={this.resetProjectId}
            />
            {this.renderDateSelectors()}
            {this.renderAuthorSelector()}
            <button
              type="button"
              id="toggleAdvancedFilters"
              className="btn btn-outline-secondary m-2"
              onClick={this.toggleAdvSearchCollapse}
            >
              {advSearchCollapsed ? "Show Advanced Filters" : "Hide Advanced Filters"}
              <FontAwesomeIcon
                className="ml-2"
                icon={advSearchCollapsed ? "angle-down" : "angle-up"}
              />
            </button>
            <Collapse isOpen={!advSearchCollapsed}>
              {this.renderAdvancedFilters()}
            </Collapse>
          </form>
        </ModalBody>
        <ModalFooter>
          <div className="form-row form-group">
            <span className="mr-3 my-auto">
              <small>Results will open in a new tab.</small>
            </span>
            <button
              className="btn btn-primary"
              id="adrSearchSubmit"
              name="adrSearchSubmit"
              onClick={this.handleSubmit}
              disabled={!projectId || searching}
            >
              {searching && (
                <span className="mr-2 mt-1">
                  <FontAwesomeIcon
                    icon="spinner"
                    className="loading-spinner"
                    style={{ color: "white" }}
                  />
                </span>
              )}
              {searching ? "Searching..." : "Search"}
            </button>
            <button
              className="btn btn-secondary ml-2"
              color="secondary"
              onClick={this.handleClose}
            >
              Cancel
            </button>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  projLocationLists: state.locations.projLocationLists || null,
  projKeywordLists: state.keywords.projKeywordLists || null,
  projItemLists: state.bidItems.projItemLists || null,
  projCcoLists: state.ccos.projCcoLists || null,
  projContractorLists: state.contractors.projContractorLists || null,
  projLaborLists: state.labors.projLaborLists || null,
  projEquipLists: state.equipment.projEquipLists || null,
  projStaffLists: state.projects.projectStaffLists || [],
  fetching:
    state.locations.fetching ||
    state.keywords.fetching ||
    state.bidItems.fetching ||
    state.ccos.fetching ||
    state.contractors.fetching ||
    state.labors.fetching ||
    state.equipment.fetching ||
    state.projects.fetching,
  searching: state.adr.searching,
  // Set only when modifying an existing results tab (tabId is that tab's id).
  prevSearchParams:
    (state.adr.openAdrLists[ownProps.tabId] &&
      state.adr.openAdrLists[ownProps.tabId].searchParams) ||
    null,
});

export default connect(mapStateToProps)(AdrSearchModal);
